export enum BrowserRoute {
  index = '/',
  notFound = '/not-found',
  organization = '/organization/:id',
}
